import { randomString } from "@common/core/utils/random-string";
import { hasClass } from "./has-class";
import { Project } from "src/app/shared/projects/Project";

export function createDocFromHtml(html: string, project: Project): Document {
  console.log("createDocFromHtml");

  const dom = new DOMParser().parseFromString(html?.trim(), "text/html");
  const tagTypeList = [
    "a",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "ul",
    "li",
    "ol",
  ];
  const tw = dom.createTreeWalker(dom.documentElement, NodeFilter.SHOW_ELEMENT);
  let next;
  while ((next = tw.nextNode())) {
    next.dataset.arId = randomString(10);
    // adding open-accessibility-text class to all text nodes
    if (
      tagTypeList.includes(next.tagName.toLowerCase()) &&
      !hasClass(next, "open-accessibility-text")
    ) {
      next.classList.add("open-accessibility-text");
    }
    // if domain_name is not null then replace all aws links with domain_name
    if (
      project.domain_name != null &&
      checkWebsitePulishedSuccessfuly(project)
    ) {
      // don't use this techniqe if the id of the node matched on this id array
      const idArray = [
        "custom-accessibility-css",
        "accessibility-css",
        "accessibility-js",
        "accessibility-local-js",
        "accessibility-initializer-js",
        "cookie-consent-css",
        "custom-cookie-consent-css",
        "cookie-consent-js",
        "font-awesome4-initial",
        "font-awesome5-initial",
        "material-design-iconic-font-initial",
        "boxicons-initial",
        "preview-css",
      ];
      if(!idArray.includes(next.getAttribute('id'))){ {
          if (["a", "link", "img", "script"].includes(next.tagName.toLowerCase())) {
            const attributeTag =
              next.tagName.toLowerCase() == "img" ||
              next.tagName.toLowerCase() == "script"
                ? "src"
                : "href";
            let link = next.getAttribute(attributeTag);
            const pattern = new RegExp("amazonaws.com");
            if (pattern.test(link)) {
              const projectPath = link
                .substr(link.indexOf("/projects/"))
                .split("/")
                .splice(5)
                .join("/");
              next.setAttribute(
                attributeTag,
                `https://www.${project.domain_name}/${projectPath}`
              );
            }
          }
        }
      }
    }
    // if a contains #something then replace it with s3 url or if domain is ther then use domain
    const pattern2 = new RegExp("^\#\w+");
    if (pattern2.test(next.getAttribute("href")) && next.tagName.toLowerCase() == "a") {
      const linkValue = next.getAttribute("href");
      if(project.domain_name != null &&
        checkWebsitePulishedSuccessfuly(project)){
          next.setAttribute('href', `https://www.${project.domain_name}${linkValue}`);
      }
    }
    // need to check and set some attributes for following standard
    const tagName = next.tagName.toLowerCase();
    if(tagName == 'li'){
      next.setAttribute('role','button');
      next.setAttribute('aria-label','button');
      next.setAttribute('tabindex','0');
    }
    else if(tagName == 'a'){
      next.setAttribute('aria-label','Opens in a new tab');
      next.setAttribute('tabindex','0');
      next.setAttribute('role','button');
      next.setAttribute('aria-haspopup','true');
      next.setAttribute('aria-expanded','false');
    }
    else if((tagName == 'span' && next.getAttribute('id') == 'cc-main') || (tagName == 'span' && next.classList.contains('pointer'))){
      next.setAttribute('role','button');
      next.setAttribute('aria-label','button');
      next.setAttribute('tabindex','0');
    }
    
    else if(tagName == 'img'){
      next.setAttribute('aria-label','image');
      next.setAttribute('role','img');
      next.setAttribute('alt','this is a image');
    }
    else if(tagName == 'svg' || tagName == 'i'){
      
      next.setAttribute('role','presentation');
    }
    else if(tagName == 'p'){
      
      next.setAttribute('role','heading');
    }
    else if(tagName == 'html'){
      
      next.setAttribute('lang','en');
    }
    else if(tagName == 'meta' && next.getAttribute('name') == 'viewport'){
      
      next.setAttribute('content','width=device-width, initial-scale=1, maximum-scale=2, user-scalable=yes');
    }
    else if(tagName == 'span' && (next.classList.contains('carousel-control-prev-icon') || next.classList.contains('carousel-control-next-icon'))){
      
      next.setAttribute('role','presentation');
    }
    
  }
  return dom;
}

export function checkWebsitePulishedSuccessfuly(project: Project) {
  return (
    project.isSSLConfigured == 1 &&
    project.ssl_exipre_date != null &&
    project.website_publish_status == 1 &&
    project.final_distribution_update_status == "success" &&
    project.final_distribution_status == "Deployed"
  );
}

export function deleteCookie(cookieName: string) {
  document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
